import { render, staticRenderFns } from "./AssetCardMinimalistComponent.vue?vue&type=template&id=6db5c722&"
import script from "./AssetCardMinimalistComponent.vue?vue&type=script&lang=js&"
export * from "./AssetCardMinimalistComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssetCardMinimalistComponent.vue?vue&type=style&index=0&id=6db5c722&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports